(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-landing-product-sticky"] && !Shopify.designMode) return;
  try {
    
  $('#add-to-cart-sticky').click(function (e) {
    e.preventDefault();
    $('#add-to-cart-form #product-add-to-cart').trigger('click');
  });
  showStickyButtons();
  $(window).scroll(function () {
    showStickyButtons();
  });
  $(window).resize(function () {
    showStickyButtons();
  });
  function showStickyButtons() {
    var scrollTop = $(window).scrollTop();
    var pos = $('.wrapper-container > section').eq(1).offset().top;
    if (pos < scrollTop) {
      $('.product-sticky-buttons').addClass('shown');
      $('body').addClass('have-bottom-sticky');
    } else {
      $('.product-sticky-buttons').removeClass('shown');
      $('body').removeClass('have-bottom-sticky');
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-landing-results-block"] && !Shopify.designMode) return;
  try {
    
var l_galleryTop2, l_galleryThumbs2, l_galleryThumbs3;
jQuery(document).ready(function($) {
  l_galleryTop2 = new Swiper('.gallery-top-2', {
      spaceBetween: 10, 
  });
  l_galleryTop2.on('slideChangeTransitionEnd', function(swiper) {
    var activeIndex = l_galleryTop2.activeIndex;
    $(l_galleryThumbs2.slides).removeClass('is-selected');
    $(l_galleryThumbs2.slides).eq(activeIndex).addClass('is-selected');
    l_galleryThumbs2.slideTo(activeIndex, 500, false);
    $(l_galleryThumbs3.slides).removeClass('is-selected');
    $(l_galleryThumbs3.slides).eq(activeIndex).addClass('is-selected');
    l_galleryThumbs3.slideTo(activeIndex, 500, false);
  });
  l_galleryThumbs2 = new Swiper('.gallery-thumbs-2', {
      spaceBetween: 20,
      freeMode: true,
      centeredSlides: false,
      direction: ($('.gallery-thumbs-2').hasClass('vertical') ? 'vertical' : 'horizontal'),
      slidesPerView: 'auto',
      touchRatio: 0.2, 
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
  });
  l_galleryThumbs2.on('click', function(swiper, event) {
    var clicked = l_galleryThumbs2.clickedIndex
    l_galleryThumbs2.activeIndex = clicked; //don't need this
    //l_galleryThumbs2.updateClasses() //don't need this
    $(l_galleryThumbs2.slides).removeClass('is-selected');
    $(l_galleryThumbs2.clickedSlide).addClass('is-selected');
    l_galleryTop2.slideTo(clicked,500, false);
  });
  l_galleryThumbs3 = new Swiper('.gallery-thumbs-3', {
      spaceBetween: 20,
      freeMode: true,
      centeredSlides: false,
      direction: 'horizontal',
      slidesPerView: 'auto',
      touchRatio: 0.2, 
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
  });
  l_galleryThumbs3.on('click', function(swiper, event) {
    var clicked = l_galleryThumbs3.clickedIndex
    l_galleryThumbs3.activeIndex = clicked; //don't need this
    //l_galleryThumbs3.updateClasses() //don't need this
    $(l_galleryThumbs3.slides).removeClass('is-selected');
    $(l_galleryThumbs3.clickedSlide).addClass('is-selected');
    l_galleryTop2.slideTo(clicked,500, false);
  });
  $(l_galleryThumbs2.slides).eq(0).addClass('is-selected'); 
  $(l_galleryThumbs3.slides).eq(0).addClass('is-selected');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-landing-video-block"] && !Shopify.designMode) return;
  try {
         
  $('.video-landing-block .video-hold').each(function() {
      var $container = $(this);
      var $btn = $(this).find('.play-btn');
      var video = $(this).find('video')[0];
      video.onended = function() {
          $container.removeClass('playing'); 
      };

      $btn.click(function(e) {
          e.preventDefault();
          if($container.hasClass('playing')) {
              $container.removeClass('playing');
              video.pause();
          } else {
              video.play();
              $container.addClass('playing');
          }
      });
  });

  $('.video-landing-block [data-play-video-id]').click(function(e) {
    e.preventDefault();
    var id = $(this).data('play-video-id');
    $('[data-video-id="'+id+'"]').find('.play-btn').trigger('click');
  });

  } catch(e) { console.error(e); }
})();
})();
